import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../Utilities/Api";

class serverAphApi {

    static addAphQueueItem(aphCatalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `aph/queue`,
                requestTypes.POST,
                JSON.stringify({aphCatalogItemId}),
                apiConstants.successMessage.queue.ADD,
            ),
        );
    }
}

export const aphApi = config.environment.MODE === config.modes.SERVER ? serverAphApi : serverAphApi;
